import { mobileWidth } from 'components/layout/leftMenu/consts';

let storeInstance = null;

function onResize() {
    storeInstance.commit('setWindowWidth', window.innerWidth);
    storeInstance.commit('setIsMobileView', storeInstance.getters.windowWidth <= mobileWidth);
}

export function viewSizeInit(store) {
    storeInstance = store;
    onResize();
    window.addEventListener('resize', onResize);
}

export const viewSizeStore = {
    state: {
        isMobileView: false,
        windowWidth: null
    },
    mutations: {
        setIsMobileView(state, isMobileView) {
            state.isMobileView = isMobileView;
        },
        setWindowWidth: (state, windowWidth) => {
            state.windowWidth = windowWidth;
        }
    },
    getters: {
        windowWidth: (state) => state.windowWidth,
        isMobileView: (state) => state.isMobileView
    }
};
